<!-- <div class="container-fluid m-0 p-0 bg-primary" *ngIf="DISPLAY_ENV_BAR" >
  <h6 class="text-white text-center p-2">Este proyecto esta corriendo en el entorno de: {{ENV_NAME}}</h6>
</div> -->
<app-pwa-update></app-pwa-update>
<router-outlet></router-outlet>
